export type { DialogProps, ModalHeaderProps } from '@/ui/Dialog'
export { default } from '@/ui/Dialog'
export { ModalHeader } from '@/ui/Dialog'
